module.exports = __webpack_public_path__ + "img/affiliate-program.6e5ff658.svg";